//index.js
import ConfirmationUploadDialog from './ConfirmationUploadDialog';
import IncomeFileUploadDialog from './IncomeFileUploadDialog';
import NewDirectPaymentDialog from './NewDirectPaymentDialog';

export {
  ConfirmationUploadDialog,
  IncomeFileUploadDialog,
  NewDirectPaymentDialog,
};
